var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isStatusRecebido)?_c('span',[_c('v-icon',{attrs:{"small":"","color":"success"}},[_vm._v("mdi-check-circle")]),_vm._v(" Recebido pelo fornecedor ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }